<ng-container *ngIf="isLoaded; else loaderBlock">
  <div
    class="landing"
    *transloco="let t">
    <div
      class="landing_hero __full-screen"
      appBackgroundBranded>
      <div class="landing_hero_main">
        <div class="fb-panel">
          <app-company-logo class="fb-panel_logo"></app-company-logo>

          <h2 class="fb-panel_title">{{ t('auth.login.email-change.' + status + '.title') }}</h2>

          <div class="fb-panel_row">{{ t('auth.login.email-change.' + status + '.text', { seconds: delay }) }}</div>

          <button
            class="btn __l __block"
            (click)="login()">
            {{ t('common.login') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loaderBlock>
  <app-icon
    class="layout_spinner"
    name="spinner"></app-icon>
</ng-template>
